import React from "react"

const Image = props => {
  const divStyle = {
    backgroundPosition: props.position
  };

  return <div style={divStyle} className="audyem-key audyem-key--circle"/>
}

export default Image
